import React from "react";

function normalizeName(name) {
  if (!name) return "";
  return String(name)
    .replace(/\.[^.]+$/, "")
    .toUpperCase();
}

export default function UploadSelectedFilesPanel({
  selectedFiles = [],
  requiredFiles = [],
  title,
}) {
  const selectedSet = new Set(
    (selectedFiles || []).map((f) => normalizeName(f)),
  );
  const hasRequired = Array.isArray(requiredFiles) && requiredFiles.length > 0;

  if (hasRequired) {
    const checkedCount = requiredFiles.filter((file) =>
      selectedSet.has(normalizeName(file)),
    ).length;
    const total = requiredFiles.length;

    return (
      <div className="upload-files-panel">
        <div className="upload-files-panel__header">
          <span>{title || "Required Files"}</span>
          <span className="upload-files-panel__badge">
            {checkedCount}/{total}
          </span>
        </div>
        <div className="upload-files-panel__progress-track">
          <div
            className="upload-files-panel__progress-bar"
            style={{
              width: `${total > 0 ? (checkedCount / total) * 100 : 0}%`,
            }}
          />
        </div>
        <div className="upload-files-panel__list">
          {requiredFiles.map((fileName) => {
            const checked = selectedSet.has(normalizeName(fileName));
            return (
              <div
                key={fileName}
                className={`upload-files-panel__item ${checked ? "is-checked" : ""}`}
              >
                <span className="upload-files-panel__dot" />
                <span className="upload-files-panel__text">{fileName}.csv</span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className="upload-files-panel">
      <div className="upload-files-panel__header">
        <span>{title || "Selected Files"}</span>
        <span className="upload-files-panel__badge">
          {selectedFiles.length}
        </span>
      </div>
      <div className="upload-files-panel__list">
        {selectedFiles.length === 0 ? (
          <div className="upload-files-panel__empty">
            No files selected yet.
          </div>
        ) : (
          selectedFiles.map((fileName) => (
            <div key={fileName} className="upload-files-panel__item is-checked">
              <span className="upload-files-panel__dot" />
              <span className="upload-files-panel__text">{fileName}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// src/components/UploadSelectedFilesPanel.js